import { Suspense, lazy, useEffect, useState } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { fetchMaintenanceState } from './services/featureFlags';
import BrandLogo from './components/BrandLogo';
import { ConnectivityBanner } from './components/ConnectivityBanner';

const AuthenticatedApp = lazy(() => import('./AuthenticatedApp.jsx'));
const PublicInvoicePage = lazy(() => import('./pages/PublicInvoicePage.jsx'));
const RetailPublicInvoicePage = lazy(() => import('./pages/inv/PublicInvoicePage.jsx'));
const PublicStorefrontPage = lazy(() => import('./pages/PublicStorefrontPage.jsx'));

function PageLoader() {
  return (
    <div className="app-container">
      <div className="loader-wrap loader-wrap--full">
        <div className="loader" />
      </div>
    </div>
  );
}

export default function App() {
  const [ready, setReady] = useState(false);
  const [maintenance, setMaintenance] = useState({
    maintenanceMode: false,
    maintenanceMessage: '',
  });

  useEffect(() => {
    let alive = true;
    const load = async () => {
      const state = await fetchMaintenanceState(2000);
      if (!alive) return;
      setMaintenance(state);
      setReady(true);
    };
    load();
    return () => {
      alive = false;
    };
  }, []);

  const checkAgain = async () => {
    const latest = await fetchMaintenanceState(2000);
    setMaintenance(latest);
    if (!latest.maintenanceMode) {
      window.location.reload();
    }
  };

  if (!ready) {
    return <PageLoader />;
  }

  if (maintenance.maintenanceMode) {
    return (
      <div className="app-container" style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', padding: '24px' }}>
        <div style={{ maxWidth: 560, textAlign: 'center' }}>
          <div style={{ marginBottom: 16 }}>
            <BrandLogo className="wb-brand-logo wb-brand-logo--maintenance" />
          </div>
          <h1 style={{ margin: 0 }}>We&apos;ll be back shortly</h1>
          <p style={{ color: '#5f4d3a' }}>
            We&apos;re doing a quick update to make WorkBill better. This usually takes a few minutes.
          </p>
          {maintenance.maintenanceMessage ? (
            <p style={{ color: '#7f6a52' }}>{maintenance.maintenanceMessage}</p>
          ) : null}
          <button type="button" onClick={checkAgain}>Check again</button>
        </div>
      </div>
    );
  }

  return (
    <BrowserRouter>
      <ConnectivityBanner />
      <Suspense fallback={<PageLoader />}>
        <Routes>
          <Route path="/inv/:invoiceId" element={<RetailPublicInvoicePage />} />
          <Route path="/public/invoice/:publicId" element={<PublicInvoicePage />} />
          <Route path="/store/:slug" element={<PublicStorefrontPage />} />
          <Route path="*" element={<AuthenticatedApp />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}
